export default __webpack_public_path__ + "static/PromptIconSeven-773dad137dba9020748513d781670f71.png";